import { useState, useRef } from 'react';
import type { DecryptRevealState } from '../components/entities/EncryptedAttributeField';

export interface EncryptedFieldState {
    decryptReveal: DecryptRevealState;
    setDecryptReveal: React.Dispatch<React.SetStateAction<DecryptRevealState>>;
    revealedEncryptedFieldNames: string[];
    setRevealedEncryptedFieldNames: React.Dispatch<React.SetStateAction<string[]>>;
    encryptedFieldsClearOnSave: string[];
    setEncryptedFieldsClearOnSave: React.Dispatch<React.SetStateAction<string[]>>;
    encryptedCreateVisible: Record<string, boolean>;
    setEncryptedCreateVisible: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
    encryptedEditStoredVisible: Record<string, boolean>;
    setEncryptedEditStoredVisible: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
    encryptedViewDecryptedByName: Record<string, string>;
    setEncryptedViewDecryptedByName: React.Dispatch<React.SetStateAction<Record<string, string>>>;
    encryptedViewPlainVisible: Record<string, boolean>;
    setEncryptedViewPlainVisible: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
    revealedDecryptedCacheRef: React.MutableRefObject<Record<string, string>>;
}

export function useEncryptedFieldState(): EncryptedFieldState {
    const [decryptReveal, setDecryptReveal] = useState<DecryptRevealState>(null);
    const [revealedEncryptedFieldNames, setRevealedEncryptedFieldNames] = useState<string[]>([]);
    const [encryptedFieldsClearOnSave, setEncryptedFieldsClearOnSave] = useState<string[]>([]);
    const [encryptedCreateVisible, setEncryptedCreateVisible] = useState<Record<string, boolean>>({});
    const [encryptedEditStoredVisible, setEncryptedEditStoredVisible] = useState<Record<string, boolean>>({});
    const [encryptedViewDecryptedByName, setEncryptedViewDecryptedByName] = useState<Record<string, string>>({});
    const [encryptedViewPlainVisible, setEncryptedViewPlainVisible] = useState<Record<string, boolean>>({});
    const revealedDecryptedCacheRef = useRef<Record<string, string>>({});

    return {
        decryptReveal,
        setDecryptReveal,
        revealedEncryptedFieldNames,
        setRevealedEncryptedFieldNames,
        encryptedFieldsClearOnSave,
        setEncryptedFieldsClearOnSave,
        encryptedCreateVisible,
        setEncryptedCreateVisible,
        encryptedEditStoredVisible,
        setEncryptedEditStoredVisible,
        encryptedViewDecryptedByName,
        setEncryptedViewDecryptedByName,
        encryptedViewPlainVisible,
        setEncryptedViewPlainVisible,
        revealedDecryptedCacheRef,
    };
}
